// GraphQL Queries - For direct use if needed
export const GET_CHANNELS = /* GraphQL */ `
    query GetChannels($userId: String!) {
        getChannels(userId: $userId) {
            _id
            name
            description
            type
            members
            iconName
            referenceNo
            extraData
            customer {
                name
                company
                email
                clientId
            }
            senderAvatar
            isExternal
            isApplicationLinked
            status
            priority
            priorityNote
            createdAt
            updatedAt
            lastSenderId
            firstCustomerMessageAt
            firstAgentResponseAt
            lastCustomerMessageAt
            totalResponseTimeSeconds
            responseCount
            applicationStatus
        }
    }
`;

export const GET_CHANNEL_READS_BY_USER_ID = /* GraphQL */ `
    query GetChannelReadsByUserId($userId: ID!, $limit: Int, $nextToken: String) {
        getChannelReadsByUserId(userId: $userId, limit: $limit, nextToken: $nextToken) {
            items {
                channelId
                userId
                lastReadMessageId
                unreadCount
                updatedAt
            }
            nextToken
        }
    }
`;

export const GET_CHANNEL_READ_BY_CHANNEL_AND_USER = /* GraphQL */ `
    query GetChannelReadByChannelAndUser($channelId: ID!, $userId: ID!) {
        getChannelReadByChannelAndUser(channelId: $channelId, userId: $userId) {
            channelId
            userId
            lastReadMessageId
            unreadCount
            updatedAt
        }
    }
`;

export const GET_ALL_CHANNELS = /* GraphQL */ `
    query GetAllChannels($limit: Int, $nextToken: String, $sortBy: String, $sortOrder: String, $filter: ChannelFilterInput) {
        getAllChannels(limit: $limit, nextToken: $nextToken, sortBy: $sortBy, sortOrder: $sortOrder, filter: $filter) {
            items {
                _id
                name
                description
                type
                members
                iconName
                referenceNo
                extraData
                customer {
                    name
                    company
                    email
                    clientId
                }
                senderAvatar
                isExternal
                isApplicationLinked
                status
                priority
                priorityNote
                priorityRank
                createdAt
                updatedAt
                lastSenderId
                firstCustomerMessageAt
                firstAgentResponseAt
                lastCustomerMessageAt
                totalResponseTimeSeconds
                responseCount
                internalNotes
                applicationStatus
            }
            nextToken
        }
    }
`;

export const GET_CHANNEL = /* GraphQL */ `
    query GetChannelById($channelId: ID!) {
        getChannelById(channelId: $channelId) {
            _id
            name
            description
            type
            members
            iconName
            referenceNo
            extraData
            customer {
                name
                company
                email
                clientId
            }
            senderAvatar
            isExternal
            isApplicationLinked
            status
            priority
            priorityNote
            createdAt
            updatedAt
            lastSenderId
            firstCustomerMessageAt
            firstAgentResponseAt
            lastCustomerMessageAt
            totalResponseTimeSeconds
            responseCount
            internalNotes
            applicationStatus
        }
    }
`;

export const GET_MESSAGES = /* GraphQL */ `
    query GetMessages($channelId: ID!, $limit: Int, $nextToken: String) {
        getMessages(channelId: $channelId, limit: $limit, nextToken: $nextToken) {
            items {
                _id
                channelId
                content
                senderId
                sender {
                    _id
                    firstName
                    lastName
                    avatar
                }
                files
                isFromBot
                createdAt
                updatedAt
            }
            nextToken
        }
    }
`;

export const GET_CHANNELS_BY_TYPE = /* GraphQL */ `
    query GetChannelsByType($type: [String], $limit: Int, $nextToken: String, $sortBy: String, $sortOrder: String) {
        getChannelsByType(type: $type, limit: $limit, nextToken: $nextToken, sortBy: $sortBy, sortOrder: $sortOrder) {
            items {
                _id
                name
                description
                type
                members
                iconName
                referenceNo
                extraData
                customer {
                    name
                    company
                    email
                    clientId
                }
                senderAvatar
                isExternal
                isApplicationLinked
                status
                priority
                priorityNote
                priorityRank
                createdAt
                updatedAt
                lastSenderId
                firstCustomerMessageAt
                firstAgentResponseAt
                lastCustomerMessageAt
                totalResponseTimeSeconds
                responseCount
                internalNotes
                applicationStatus
            }
            nextToken
        }
    }
`;

export const GET_CHANNEL_STATS = /* GraphQL */ `
    query GetChannelStats($statuses: [String], $serviceTypes: [String]) {
        getChannelStats(statuses: $statuses, serviceTypes: $serviceTypes) {
            totalCount
            activeCount
            highPriorityCount
            avgResponseTimeSeconds
            avgResponseTimeLast24h
            avgResponseTimePrev24h
            byType {
                type
                count
            }
        }
    }
`;

export const GET_FILES = /* GraphQL */ `
    query GetFiles($channelId: ID!, $limit: Int, $nextToken: String) {
        getFiles(channelId: $channelId, limit: $limit, nextToken: $nextToken) {
            items {
                _id
                channelId
                content
                files
                sender {
                    _id
                    firstName
                    lastName
                    avatar
                }
                createdAt
                updatedAt
            }
            nextToken
        }
    }
`;
